// AdsRail.js
import { useLocation, useParams } from 'react-router-dom';
import Ads from './Ads.js';

// Pages avec du contenu éditorial suffisant pour justifier des annonces
const adsAllowedPaths = ['/library', '/about', '/history'];

function isAdsAllowed(pathname) {
  // Pages statiques autorisées
  if (adsAllowedPaths.some(p => pathname === p || pathname.startsWith(p + '/'))) {
    return true;
  }

  // Pages de détail d'archive : /item/:id, /game/:id, /character/:id, /sword/:id
  // (mais PAS /item, /game, /character, /sword tout court, qui sont le jeu du jour)
  const archiveDetailPattern = /^\/(item|game|character|sword)\/[^/]+$/;
  if (archiveDetailPattern.test(pathname)) {
    return true;
  }

  return false;
}

export function AdRailLeft() {
  const location = useLocation();
  if (!isAdsAllowed(location.pathname)) return null;
  return (
    <div className="pub-rail-gauche">
      <Ads slot="8876856463" format="vertical" />
    </div>
  );
}

export function AdRailRight() {
  const location = useLocation();
  if (!isAdsAllowed(location.pathname)) return null;
  return (
    <div className="pub-rail-droit">
      <Ads slot="8876856463" format="vertical" />
    </div>
  );
}